export default __webpack_public_path__ + "static/media/group-room-disabled.51e7dcc3.svg";